import type { BandOption } from "../types/consoleTypes";

/** Band options for Upload Raw Bytes modal */
export const ALL_BANDS: BandOption[] = [
  { label: "Backdoor", value: "TM-Only" },
  { label: "LeafSpace-S-band", value: "LeafSpace-S-band" },
  { label: "LeafSpace-Uhf", value: "LeafSpace-Uhf" },
];

/** Row height for virtual list (px) */
export const CONSOLE_ROW_HEIGHT = 35;

/** Default total table width when all columns selected (px) */
export const DEFAULT_TABLE_WIDTH = 1400;

/** Output modal resize bounds */
export const OUTPUT_MODAL_HEIGHT_MIN = 100;
export const OUTPUT_MODAL_HEIGHT_MAX = 500;
export const OUTPUT_MODAL_WIDTH_MIN = 200;
export const OUTPUT_MODAL_WIDTH_MAX = 1000;

/** Max year for epoch picker (Unix 2038 limit) */
export const EPOCH_MAX_YEAR = 2037;
